<template>
    <div class="preview-body">
        <div v-if="!showPageLoader">
            <div class="customer-info">
                <div class="customers-info-section">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="filter-section sub-filter">
                                <div class="row sup-heading">
                                    <div class="col-md-12 sup-heading-content">
                                        <h2 class="m-0">Preview Documents</h2>
                                        <!-- <b-button
                                            size="sm"
                                            variant="secondary"
                                            @click="pdf"
                                        >
                                            Export as PDF
                                        </b-button> -->
                                    </div>
                                </div>
                            </div>
                            <hr />
                            
                            <template
                            v-for="(document,index) in documentInfoPreview"
                            >
                            <ul v-if="(configData.documentUpload == true && document.fileName) || documentsExpiry(document,index)">
                                
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h3>{{documentName(document,index)}} Document</h3>
                                            </div>
                                        </div>
                                        <!-- <div class="flex-row" > -->
                                           
                                            <div
                                                class="image-container"
                                                v-if="document.fileName"
                                            >
                                                <img
                                                    v-if="
                                                        document.fileName &&
                                                        document.fileName
                                                            .split('.')
                                                            .pop() === 'pdf'
                                                    "
                                                    v-authenticated-image="
                                                        'customer-documents/pdf_icon.png'
                                                    "
                                                  
                                                />

                                                <img
                                                    v-else-if="document.fileName &&
                                                        document.fileName"
                                                    v-authenticated-image="
                                                        'customers/' +
                                                        document.fileName
                                                    "
                                                />

                                            </div>
                                            <!-- <div v-if="!index.includes('Back')"> -->
                                            <h3>Expiry Date</h3>
                                            <div style="
                                            padding-bottom: 50px;">
                                                {{$moment(documentsExpiry(document,index)).format('MMM D, Y')}}
                                            </div>
                                           <!-- </div> -->
                                          
                                        <!-- </div> -->
                                    </div>

                                </li>
                            </ul>
                        </template>
                            <!-- <ul>
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div class="col-md-6 mb-4">
                                                <vue-signature></vue-signature>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <b-button
                    size="sm"
                    class="mr-3"
                    variant="secondary"
                    @click="$router.go(-1)"
                >
                    Back
                </b-button>
                <b-button
                    type="button"
                    variant="primary"
                    class="primary-add-btn"
                    @click="onSubmitContinue"
                    >CONTINUE
                </b-button>
            </div>

            <div class="col-lg-4"></div>
            <b-modal
                ref="termsandconditionmodal"
                size="xl"
                title="Terms And Conditions"
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <terms-and-condition
                    @agreed="agreeToTermsAndConditions"
                ></terms-and-condition>
            </b-modal>
            <b-modal
                ref="otpmodal"
                size="sm"
                title=""
                hide-footer
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
            >
                <otp-modal
                    v-if="is_data_fetched"
                    :data="otpData"
                    heading="Verify your OTP (One Time Password)"
                    @verificationStatus="otpResponse"
                    @reSendOTP="reSendOTP"
                ></otp-modal>
            </b-modal>
            <!-- <b-modal
        ref="my-modal"
        size="lg"
        title=""
        hide-footer
        :click-to-close="false"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
    >
        <modal-setup-profile @close="handleClose"> </modal-setup-profile>
    </b-modal> -->
        </div>
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import TermsAndCondition from '@/components/registration/TermsAndCondition.vue'
import OtpModal from '@/components/registration/OtpModal.vue'
// import ModalSetupProfile from '@/components/registration/ModalSetupProfile.vue'
import request from '@/utils/request'
import _ from 'lodash'
import VueSignature from '@/components/BaseSignature.vue'

export default {
    components: {
        TermsAndCondition,
        OtpModal,
        VueSignature,
        // ModalSetupProfile,
    },
    filters: {},
    data() {
        return {
            country: process.env.VUE_APP_COUNTRY,
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
            fields: [],
            customerDetails: [],
            basicInfo: [],
            residentialInfo: [],
            declarationByCustomer: [],
            pepDeclaration: [],
            ultimateBenefit: [],
            factaDetails: [],
            otpData: null,
            is_data_fetched: false,
            sourceOfWealth: [],
            sourceOfFunds: [],
            identityInfo: null,
            documentInfo:null,
            documentInfoPreview:null,
            state_emirates_province: '',
            instance: process.env.VUE_APP_COUNTRY,
            configData: [],
            showPageLoader: true,
        }
    },
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form','getField']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        cardType(){
            return this.$store.getters.getField("identityInfo.cardType")
        },
        addExpiryObjectToDocInfo(){
           let documentInfoPreview =  this.documentInfo
           if(documentInfoPreview.nationalIdExpiry) delete documentInfoPreview.nationalIdExpiry
           if(documentInfoPreview.passportExpiry) delete documentInfoPreview.passportExpiry
           if(this.getField('type') == 'company') delete documentInfoPreview.identityBack
           if (!this.configData.documentUpload && this.getField('type')!='company'){
               documentInfoPreview = {}
               documentInfoPreview.nationalIdExpiry = {}
               documentInfoPreview.passportExpiry = {}
           }
           else if( (this.tempCountry == 'PK' || 
               (this.tempCountry == 'UK' && this.cardType && this.cardType != 'passport')) &&
               this.getField('identityInfo.passport.expiryDate') && this.getField('type')!='company'){
               documentInfoPreview.passportExpiry = {}
           }else if( (this.tempCountry == 'UK' && this.cardType && this.cardType == 'passport') &&
               this.getField('identityInfo.expiryDate') && this.getField('type')!='company'){
                delete documentInfoPreview.identityBack
                documentInfoPreview.nationalIdExpiry = {}
           }
          
           console.log("documentInfoPreview",documentInfoPreview)
           return documentInfoPreview
        },
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */

    created() {
        this.configData = this.$store.state.configData
        this.customerDetails = this.$store.state.registration.form
        // this.setValues()
        this.getRecords()

        this.identityInfo = this.$store.getters.getField(
            'documentInfo.identity'
        )
        this.documentInfo = this.$store.getters.getField(
            'documentInfo'
        )
        this.documentInfoPreview = this.addExpiryObjectToDocInfo
    },
    mounted() {},
    methods: {
       
        documentsExpiry(document,index){
            console.log("in the doc epiry")
            let expiryObj =  this.getField('identityInfo')
            let twoDocsCountry = ['UAE','Qatar']
        if(this.getField("type")=='company'&& index =='identity'){
            return expiryObj.expiryDate
         }
         else if(  !twoDocsCountry.includes(this.tempCountry) && this.getField("identityInfo.cardType") !='passport' 
              && ["identity","identityBack"].includes(index) || index == 'nationalIdExpiry'
            ){
                    if(index=="identity" || index == 'nationalIdExpiry'){
                        return expiryObj.expiryDate
                    }
                    else if(index =="identityBack" && this.getField('type')!='company'){
                        return expiryObj.expiryDate
                    }
          }
          else if(  !twoDocsCountry.includes(this.tempCountry) && this.cardType =='passport' 
              && ["identity"].includes(index) && this.getField("type")!='company'
            ){
                    if(index=="identity"){
                        return expiryObj.passport.expiryDate
                    }
          }
          else if ((twoDocsCountry.includes(this.tempCountry) && index=="identity" ) ||
                    index=='passportExpiry' && this.getField("type")!='company'){
                    // if(index =="identity"){
                        return expiryObj.passport.expiryDate
                    // }
                    // else if(index =="identityBack"){
                    //     return "Passport Back"
                    // }
          }
          else if(twoDocsCountry.includes(this.tempCountry) && ["fieldEmiratesID","fieldEmiratesIDBack"].includes(index)
                 && this.getField("type")!='company'
          ){
                    if(index=="fieldEmiratesID"){
                        return expiryObj.expiryDate
                    }
                    else if(index =="fieldEmiratesIDBack"){
                        return expiryObj.expiryDate
                    }
          }
         
        
        },
        documentName(document,index){
            console.log("Document",document,index)
          let twoDocsCountry = ['UAE','Qatar']
         if(this.getField("type")=='company' && index =='identity'){
            return 'Certificate Of Incorporation'
         }
         else if(  !twoDocsCountry.includes(this.tempCountry) && this.cardType!='passport' 
              && ["identity","identityBack"].includes(index) || index == 'nationalIdExpiry'
              && this.getField("type")!='company'
            ){
                    if(index=="identity"){
                        return "ID Front"
                    }
                    else if(index =="identityBack" && this.getField('type')!='company'){
                        return "ID Back"
                    }
                    else if(index == 'nationalIdExpiry'){
                        return "National ID"
                    }
          }
          else if(  !twoDocsCountry.includes(this.tempCountry) && this.cardType =='passport' 
              && ["identity"].includes(index) && this.getField("type")!='company'
            ){
                    if(index=="identity"){
                        return "Passport"
                    }
          }
          else if ((twoDocsCountry.includes(this.tempCountry) && index=="identity") || index=="passportExpiry" 
                   && this.getField("type")!='company' 
           ){
                    // if(index =="identity"){
                        return "Passport"
                    // }
                    // else if(index =="identityBack"){
                    //     return "Passport Back"
                    // }
          }
          else if(twoDocsCountry.includes(this.tempCountry) && ["fieldEmiratesID","fieldEmiratesIDBack"].includes(index)
                  && this.getField("type")!='company' 
          ){
                    if(index=="fieldEmiratesID"){
                        return "ID Front"
                    }
                    else if(index =="fieldEmiratesIDBack"){
                        return "ID Back"
                    }
          }
         
        
        },
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/fields`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        visibleTo: this.$store.getters.form.type,
                    },
                })
                this.showPageLoader = false
                this.fields = data.data
            } catch (error) {
                console.log(error)
            }
            this.$store.commit('setLoading', false)
        },
        handleClose(event) {
            this.$refs['my-modal'].hide()
        },
        editSetupProfile() {
            this.$refs['my-modal'].show()
            // this.$ref.modalEditProfile.show()
            // if (this.$route.meta.publicRegistration === true) {
            //     this.$router.push({
            //         name: 'public-registration-setup-profile-edit',
            //         params: {
            //             dataSegmentId: this.dataSegmentId,
            //         },
            //     })
            // } else {
            //     // this.$router.push('/register-customer/finish')
            //     alert('Error in Opening Setup Profile Edit')
            // }
        },
        async onSubmitContinue() {
            try{
            // this.$store.commit('setLoading', true)
            this.$refs.termsandconditionmodal.show()
            // let params = this.$route.params
            //     let dataSegmentId = params.dataSegmentId
            //     let userToken = params.token
            //     console.log(params)

                // const formData = {
                //     userToken: userToken,
                //     dataSegmentId: dataSegmentId,
                // }
                // const formData = this.$store.state.registration.form
                // formData.dataSegmentId = this.dataSegmentId
                // formData.userToken = userToken
                // let encryptedForm = this.CryptoJS.AES.encrypt(
                //         JSON.stringify(formData),
                //         process.env.VUE_APP_CRYPTO_SECERT_KEY
                //     ).toString()
                //     console.log('Encryption: ' + encryptedForm)
                //     const tempRequest = { data: encryptedForm }
                    // const { data } = await request({
                    //     url: '/customers/save-document-temp-upload',
                    //     method: 'post',
                    //     data: formData,
                    // })
                
            // this.$router.push({name: 'document-upload-finish'})
                }catch(error){
                    console.log('save-document-temp-upload error: ' + error)
                    this.$store.commit('setLoading', false)
                }
           
        },
        agreeToTermsAndConditions() {
            // this.$refs.termsandconditionmodal.hide()
            this.sendOPT()
        },
        async sendOPT() {
            try {
                // console.log("Full :"+JSON.stringify(this.$store.state.registration.form) )
                let phoneNumber =
                    this.$store.state.registration.form.contactInfo.phoneNumber
                let fullName =
                    this.$store.state.registration.form.basicInfo.firstName
                let email =
                    this.$store.state.registration.form.contactInfo.email

                this.$store.commit('setLoading', true)
                // let phoneNumber = '923333728009'
                console.log('PHONE NUMBER: ' + phoneNumber)

                const formData = {
                    mobileNo: phoneNumber,
                    name: fullName,
                    email: email,
                }
                const { data } = await request({
                    url: `/configurations/generate-otp/`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    this.is_data_fetched = true
                    data.data.phoneNumber = phoneNumber
                    this.otpData = data

                    this.$refs.termsandconditionmodal.hide()
                    this.$refs.otpmodal.show()
                }

                this.showPageLoader = false
                console.log('Response OTP data: ' + JSON.stringify(data))
                // this.fields = data.data
            } catch (error) {
                console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        async otpResponse(data) {
            // console.log('emi data: ' + JSON.stringify(data))
            if (data.verificationStatus == true) {
                this.$refs.otpmodal.hide()
                this.$store.commit('setLoading', true)
                // const formData = this.$store.state.registration.form
                // formData.dataSegmentId = this.dataSegmentId
                // let registrationUrl = '/customers/face-to-face'
                // if (this.$route.meta.publicRegistration === true) {
                //     registrationUrl = '/customers/non-face-to-face'
                // }
                
                try {
                    let params = this.$route.params
                    let dataSegmentId = params.dataSegmentId
                    let userToken = params.token
                    console.log(params)

                    // const formData = {
                    //     userToken: userToken,
                    //     dataSegmentId: dataSegmentId,
                    // }
                    const formData = this.$store.state.registration.form
                    formData.dataSegmentId = this.dataSegmentId
                    formData.userToken = userToken
                    let encryptedForm = this.$encrypt(formData)
                    const tempRequest = { data: encryptedForm }
                    const { data } = await request({
                        url: '/customers/save-document-temp-upload',
                        method: 'post',
                        data: formData,
                    })
                   this.$router.push({name: 'document-upload-finish'})

                    // console.log('FormData: ' + JSON.stringify(formData))
                    // const { data } = await request({
                    //     url: registrationUrl,
                    //     method: 'post',
                    //     data: formData,
                    // })
                    // this.$store.commit('updateField', {
                    //     key: 'idenfoId',
                    //     value: data.data.idenfoId,
                    // })
                    // if (data.warning) {
                    //     this.$store.commit('setValue', {
                    //         key: 'warning',
                    //         value: data.warning,
                    //     })
                    // }

                    // if (this.$route.meta.publicRegistration === true) {
                    //     this.$router.push({
                    //         name: 'deep-registration-finish',
                    //         params: {
                    //             dataSegmentId: this.dataSegmentId,
                    //             source: this.$route.params.source,
                    //         },
                    //     })
                    // } else {
                    //     this.$router.push('/register-customer/finish')
                    // }
                    this.$store.commit('setLoading', false)
                } catch (errors) {
                    // this.$store.commit("setLoading", false);
                    // this.$store.commit("setError", errors);
                    // console.log("Errors : ", JSON.parse(JSON.stringify(errors)));
                    // console.log("Errors : ", JSON.parse(JSON.stringify(errors.errors)));

                    let allErrors = JSON.parse(JSON.stringify(errors.errors))
                    let errorsArray = []
                    for (var key in allErrors) {
                        if (allErrors.hasOwnProperty(key)) {
                            errorsArray.push(allErrors[key].message)
                        }
                    }
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', errorsArray[0])
                }
            } else {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', data.message)
            }
            // this.$store.commit('setLoading', false)
        }, // End of otpResponse() method

        async reSendOTP() {
            this.sendOPT()
        }, // End of reSendOTP() method

        addDangerClass(date) {
            let expiryDate = this.$moment(date)
            let diff = expiryDate.diff(this.$moment(), 'days')
            if (diff <= 60) {
                return 'danger'
            }
            return ''
        },
        onCloseOTPModal() {
            his.$store.commit('setLoading', false)
        },
        pdf() {
            window.print()
            // window.close()
        },
        setValues() {
            this.pepDeclaration.push(
                {
                    field: 'DO YOU CURRENTLY HOLD ANY PUBLIC POSITION?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.anyPublicPos
                            ? this.customerDetails.pepDeclaration.anyPublicPos
                            : 'N/A',
                },
                {
                    field: 'DID YOU HOLD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.posLastTwoMonths
                            ? this.customerDetails.pepDeclaration
                                  .posLastTwoMonths
                            : 'N/A',
                },
                {
                    field: 'HAVE YOU EVER HELD ANY PUBLIC POSITION?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.everPublicPosition
                            ? this.customerDetails.pepDeclaration
                                  .everPublicPosition
                            : 'N/A',
                },
                {
                    field: 'DID YOU HAVE OR HAVE YOU EVER HAD ANY DIPLOMATIC IMMUNITY?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.diplomaticImmunity
                            ? this.customerDetails.pepDeclaration
                                  .diplomaticImmunity
                            : 'N/A',
                },
                {
                    field: 'DO YOU HAVE A RELATIVE WHO HAS HELD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.relativeTwelveMonths
                            ? this.customerDetails.pepDeclaration
                                  .relativeTwelveMonths
                            : 'N/A',
                },
                {
                    field: 'DO YOU HAVE A CLOSE ASSOCIATE WHO HAS HELD ANY PUBLIC POSITION IN THE LAST 12 MONTHS?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration
                            .closeAssociateTwelveMonths
                            ? this.customerDetails.pepDeclaration
                                  .closeAssociateTwelveMonths
                            : 'N/A',
                },
                {
                    field: 'HAS THERE BEEN A CONVICTION AGAINST YOU BY A COURT OF LAW?',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.conviction
                            ? this.customerDetails.pepDeclaration.conviction
                            : 'N/A',
                },
                {
                    field: 'IF YOU HAVE ANSWERED "YES" TO ANY OF THE QUESTIONS ABOVE, PLEASE PROVIDE DETAILS:',
                    value:
                        this.customerDetails &&
                        this.customerDetails.pepDeclaration &&
                        this.customerDetails.pepDeclaration.other
                            ? this.customerDetails.pepDeclaration.other
                            : 'N/A',
                }
            )
            this.sourceOfWealth.push(
                {
                    field: 'SOURCE OF WEALTH - EACH ITEM CHECKED SHOULD BE APPROPRIATELY EVIDENCED',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfWealth &&
                        this.customerDetails.sourceOfWealth.evidenced
                            ? this.customerDetails.sourceOfWealth.evidenced
                            : 'N/A',
                },
                {
                    field: 'IF OTHER SOURCE OF FUNDS',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfWealth &&
                        this.customerDetails.sourceOfWealth.OtherEvidenced
                            ? this.customerDetails.sourceOfWealth.OtherEvidenced
                            : 'N/A',
                }
            )
            this.sourceOfFunds.push(
                {
                    field: 'SOURCE OF WEALTH - EACH ITEM CHECKED SHOULD BE APPROPRIATELY EVIDENCED',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfFunds &&
                        this.customerDetails.sourceOfFunds.evidenced
                            ? this.customerDetails.sourceOfFunds.evidenced
                            : 'N/A',
                },
                {
                    field: 'IF OTHER SOURCE OF FUNDS',
                    value:
                        this.customerDetails &&
                        this.customerDetails.sourceOfFunds &&
                        this.customerDetails.sourceOfFunds.OtherEvidenced
                            ? this.customerDetails.sourceOfFunds.OtherEvidenced
                            : 'N/A',
                }
            )
        },
    },
}
</script>

<style scoped>
.flex-row {
  display: flex;
  /* Adjust spacing between rows as needed */
  flex-wrap: wrap;
  gap: 10px; /* Add spacing between image containers */
}
.image-container {
    display: block;
    margin: 2px; /* Add some margin for spacing */
  /* Adjust width and height based on your desired preview size */
  width: 300px;
  height: 300px;

  /* Maintain aspect ratio for non-PDF images (optional) */
  aspect-ratio: 16/9;
  object-fit: cover; /* Scale image to fill container while maintaining aspect ratio (if applicable) */

  /* Optional: Border and background for styling */
  /* border: 1px solid #ddd; */
  /* background-color: #eee; */
}

.image-container img {
  object-fit: fill;
  height: 200px;
}
</style>
